import React, { Component } from 'react';
import { StyleSheet, View, Text, Animated, ScrollView, TouchableOpacity, Dimensions } from 'react-native';
import { ThemeColor } from '@qnpm/q-theme';
import { Toast } from 'qunar-react-native';
import { toJS } from 'mobx';
import { PopupLayer } from '@qnpm/q-popup-layer';
import Icon from './Icon';
import Product from './productPopLayer';

const { height, width } = Dimensions.get('window');
const layerHeight = height * 0.75;

export default class popLayer extends Component<any, any> {
    static getDerivedStateFromProps(nextProps: any, state: any) {
        if (nextProps.visible === true) {
            Ext.setSwipeBackEnabled(false);
            Animated.parallel([
                Animated.timing(state.moveValue, {
                    toValue: 0,
                    duration: 400,
                    useNativeDriver: true
                }),
                Animated.timing(state.opacity, {
                    toValue: 0.4,
                    duration: 400,
                    useNativeDriver: true
                })
            ]).start();
        }
    }

    constructor(props: any, state: any) {
        super(props, state);

        this.state = {
            moveValue: new Animated.Value(layerHeight),
            opacity: new Animated.Value(0)
        };
        this.close = this.close.bind(this);
        this.submit = this.submit.bind(this);
    }

    close() {
        if (typeof this.props.onOpenDialog === 'function') {
            this.props.onOpenDialog();
        }
    }

    submit() {
        const {
            marketing = {}, orderNo = '', submit = () => {
            }
        } = this.props || {};
        const { formData = {} } = marketing || {};
        const { orderRecords = [] } = formData || {};

        formData.flightOrderNo = orderNo;


        if (orderRecords.length > 0) {
            submit(formData);
        } else {
            Toast.show('请选择乘机人');
        }
    }

    render() {
        const { marketing = {}, visible = false, submitDisabled } = this.props || {};
        const { tipsInfo = {}, clearProductInfoList = [], formData = {}, productIndex } = marketing || {};
        const { orderRecords = [] } = formData || {};
        const { yellowTips = '' } = tipsInfo || {};
        const productInfoListLen = clearProductInfoList && Array.isArray(toJS(clearProductInfoList)) && clearProductInfoList.length;
        const flag = !orderRecords || orderRecords.length === 0;
        const dis = (flag || submitDisabled) ? styles.submitDisBtn : {};

        if (!productInfoListLen || productInfoListLen === 0) {
            return null;
        }

        return (
            <PopupLayer
                hasHeader={false}
                visible={visible}
                perHeight={75}
                style={{
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12
                }}
                onClose={this.close}>
                <View style={styles.main}>
                    {/* close */}
                    <View style={styles.hd}>
                        <Text style={styles.headerName}>选择特权使用人</Text>
                        <TouchableOpacity onPress={this.close} style={styles.closeWrapper}>
                            <Icon size={26} name='maskClose' color='#999' />
                        </TouchableOpacity>
                    </View>

                    {/* 提示 */}
                    {
                        yellowTips.length > 0
                            ? <View style={styles.yellowTips}>
                                <Text style={styles.iconBox}><Icon size={21} name='warning' color='#FF9800' /></Text>
                                <Text style={styles.yellowTipsInfo}>{yellowTips}</Text>
                            </View>
                            : null
                    }
                    <View style={styles.line} />
                    {/* 内容 */}
                    <ScrollView
                        ref='scrollView'
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                    >
                        {
                            productInfoListLen > 0
                                ? <Product marketing={marketing} productIndex={productIndex} setMarketing={this.props.setMarketing} />
                                : null
                        }
                    </ScrollView>
                    <TouchableOpacity onPress={() => {
                        if (!submitDisabled) {
                            this.submit();
                        }
                    }} style={styles.submitBtnBox}>
                        <Text style={[styles.submitBtn, dis]}>确定</Text>
                    </TouchableOpacity>
                </View>
            </PopupLayer>
        );
    }
}

const styles = StyleSheet.create({

    main: {
        width,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        backgroundColor: '#fff',
        height: layerHeight
    },
    closeWrapper: {
        position: 'absolute',
        top: 10,
        right: 6,
        padding: 5
    },
    hd: {
        // flexDirection: 'row',
        position: 'relative',
        paddingTop: 18,
        marginBottom: 18
        // backgroundColor: 'red',
        // paddingVertical: 18,
    },
    headerName: {
        fontSize: 16,
        lineHeight: 22,
        fontWeight: 'bold',
        color: '#333',
        textAlign: 'center'
    },
    // 产品相关样式
    yellowTips: {
        padding: 8,
        marginHorizontal: 24,
        marginBottom: 11,
        backgroundColor: '#FEFCEC',
        flexDirection: 'row',
        borderRadius: 4,
        alignItems: 'flex-start'
    },
    iconBox: {
        // backgroundColor: 'red',
        marginTop: -3
    },
    yellowTipsInfo: {
        flex: 1,
        color: ThemeColor.text2,
        fontSize: 11,
        lineHeight: 16
    },
    line: {
        marginHorizontal: 24,
        marginBottom: 11,
        height: 0.5,
        backgroundColor: '#eee'
    },

    // 提交按钮
    submitBtnBox: {
        paddingTop: 8,
        backgroundColor: '#fff',
        marginHorizontal: 24,
        marginBottom: 15
    },
    submitBtn: {
        height: 44,
        lineHeight: 44,
        textAlign: 'center',
        color: '#fff',
        backgroundColor: '#FE8300',
        borderRadius: 22,
        fontSize: 15,
        overflow: 'hidden',
        fontWeight: 'bold'
    },
    submitDisBtn: {
        color: '#fff',
        backgroundColor: '#DEDEDE'
    }
});
